import { IValidationRule } from "@/types"

const offerValidationRules: { [s: string]: IValidationRule } = {
    duration: {
        required: true,
        type: "integer",
        min: 1,
        max: 5000,
    },
    durationType: {
        required: true,
    },
    start: {
        required: true
    },
    language: {
        required: true,
    },
    customer: {
        required: true,
    },
    contactEmail: {
        type: "email"
    },
}

export default offerValidationRules
